import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { verifyAccount } from '../api/projects';
import '../styles/ICOListing.css';

export default function VerifyAccount() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        const token = searchParams.get('token');
        if (!token) { setStatus('error'); return; }
        verifyAccount(token).then(data => setStatus(data.success ? 'success' : 'error')).catch(() => setStatus('error'));
    }, []);

    return (
        <div className="app-wrap">
            <nav className="nav"><div className="nav-logo">ONLINEICO</div></nav>
            <div style={{ maxWidth: '600px', margin: '4rem auto', padding: '0 1.5rem', textAlign: 'center' }}>
                <div style={{ background: 'rgba(10,15,30,0.6)', backdropFilter: 'blur(20px)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: '24px', padding: '3rem' }}>
                    {status === 'loading' && <p style={{ color: '#94a3b8' }}>Verifying...</p>}
                    {status === 'success' && (
                        <>
                            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
                            <h2 style={{ color: '#34D399', fontFamily: 'Syne, sans-serif', marginBottom: '1rem' }}>Account activated!</h2>
                            <p style={{ color: '#94a3b8', marginBottom: '2rem' }}>Your account is now active. You can log in.</p>
                            <button className="auth-btn" onClick={() => navigate('/connexion')}>Log in</button>
                        </>
                    )}
                    {status === 'error' && (
                        <>
                            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>❌</div>
                            <h2 style={{ color: '#f87171', fontFamily: 'Syne, sans-serif', marginBottom: '1rem' }}>Invalid link</h2>
                            <p style={{ color: '#94a3b8', marginBottom: '2rem' }}>This link is invalid or has already been used.</p>
                            <button className="auth-btn" onClick={() => navigate('/')}>Back to listings</button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}